(function ($, window, document) {
  'use strict';
  $(function () {
    //##Variables
    var $body = $('body'),
      $window = $(window),
      $html = $('html'),
      $doc = $(document),
      $navToggle = $('.menu-toggle'),
      $searchToggle = $('.search-toggle'),
      $jsNav = $('.nav-container'),
      $jsSearch = $('.search-container'),
      isMobile = Modernizr.mq('(max-width: 768px)'),
      defaultEasing = [0.4, 0.0, 0.2, 1];
    //End Variables
    function remFontSize($element) {
      var $baseDiff = 85.375,
        $width = $window.width(),
        $fontSize = $width / $baseDiff;

      $element.css('font-size', $fontSize);
    }
    if (!isMobile) {
      remFontSize($html);
      $window.resize(function () {
        remFontSize($html);
      });
    }
    function navToggle() {
      $body.toggleClass('nav-active');
      $navToggle.toggleClass('active');
      $navToggle.attr('aria-expanded', function (i, attr) {
        return attr == 'true' ? 'false' : 'true';
      });
      $(this).parent().parent().parent().parent().find('.nav-container').fadeToggle(300);
    }
    function searchToggle() {
      $body.toggleClass('search-active');
      $searchToggle.toggleClass('active');
      $searchToggle.attr('aria-expanded', function (i, attr) {
        return attr == 'true' ? 'false' : 'true';
      });

      $(this).parent().parent().parent().parent().parent().find('.search-container').toggleClass('active');
      $(this).parent().parent().parent().parent().parent().find('.search-container').find('input[type="search"],input[type="text"]').focus();
    }
    function searchClose() {
      $body.removeClass('search-active');
      $searchToggle.removeClass('active');
      $searchToggle.attr('aria-expanded', function (i, attr) {
        return attr == 'false' ? 'false' : 'false';
      });
      $jsSearch.removeClass('active');
      $jsSearch.find('input[type="search"],input[type="text"]').blur();
    }
    function navClose() {
      $body.removeClass('nav-active');
      $navToggle.removeClass('active');
      $navToggle.attr('aria-expanded', function (i, attr) {
        return attr == 'false' ? 'false' : 'false';
      });
      $jsNav.fadeOut(300);
    }
    $navToggle.click(navToggle);
    $searchToggle.click(searchToggle);
    $jsSearch.find('input[type="search"],input[type="text"]').focus(function () {
      $(this).parent().parent().parent().addClass('search-focused');
    });
    $("#order-form input[type='checkbox']").change(function () {
      $('#order-form').submit();
    });
    $jsSearch.find('input[type="search"],input[type="text"]').blur(function () {
      $(this).parent().parent().parent().removeClass('search-focused');
    });
    $doc.keyup(function (e) {
      if (e.key === 'Escape') {
        navClose();
        searchClose();
      }
    });
    $('.event-toggle').click(function (e) {
      $(this).toggleClass('is-active');
      $(this).next().slideToggle(300).toggleClass('is-active');
    });
    //Accordion
    $('.accordion-toggle').click(function (e) {
      $(this).parent().toggleClass('active');
      $(this).next().slideToggle('300');
    });
    if (isMobile) {
      $('.filter-accordion-toggle').click(function (e) {
        $(this).parent().toggleClass('active');
        $(this).next().slideToggle('300');
      });
      /* $(".filter-tags input").change(function () {
        if ($(this).is(":checked")) {
          var thisLabel = $(this).next().html();
          $(".tags-label").html(thisLabel);
        } else {
          $(".tags-label").html("None selected");
        }
      }); */
      $('.filter-cats input').change(function () {
        var thisLabel = $(this).next().html();
        if ($(this).is(':checked')) {
          $('.years-label').html(thisLabel);
        } else {
          $('.years-label').html('None selected');
        }
      });
    }
    var myElement = document.getElementById('header-sticky');
    // construct an instance of Headroom, passing the element
    var headroom = new Headroom(myElement);
    // initialise
    headroom.init();
    $(document).on('click', 'a[href^="#"]', function (e) {
      // target element id
      var id = $(this).attr('href');

      // target element
      var $id = $(id);
      if ($id.length === 0) {
        return;
      }

      // prevent standard hash navigation (avoid blinking in IE)
      e.preventDefault();

      // top position relative to the document
      var pos = $id.offset().top;

      // animated top scrolling
      $('body, html').animate({ scrollTop: pos });
    });
    //Slider
    var sliders = document.querySelectorAll('.layout-slider');

    if (document.querySelector('.layout-slider')) {
      for (var i = 0; i < sliders.length; i++) {
        var glide = new Glide(sliders[i], {
          type: 'carousel',
          startAt: 0,
          perView: 1,
          autoplay: 7000,
        });

        glide.mount();
      }
    }
    AOS.init({
      once: true,
      offset: 50,
    });
    $body.addClass('readied');
    window.onload = function () {
      if (!isMobile) {
        lax.setup(); // init

        var updateLax = function updateLax() {
          lax.update(window.scrollY);
          window.requestAnimationFrame(updateLax);
        };

        window.requestAnimationFrame(updateLax);
      }
    };
  });
})(window.jQuery, window, document);
